import { render, staticRenderFns } from "./StreamerAudience.vue?vue&type=template&id=39826d30&"
import script from "./StreamerAudience.vue?vue&type=script&lang=js&"
export * from "./StreamerAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports